/* Florema · Cart Drawer
   - Slide-out drawer al hacer click en cart icon o tras add to cart
   - Progress bar dinámica con threshold de envío gratis (+ regalo opcional)
   - Items con qty +/- y delete via AJAX (/cart/change.js)
   - Upsell quick-add
   - Nota persistente (cart.note)
   - Total estimado actualizado en tiempo real
*/

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function fmt(amountCents) {
    if (amountCents == null) return '';
    var n = Math.round(amountCents / 100);
    var s = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + s;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function init() {
    var drawer = document.querySelector('[data-florema-cart-drawer]');
    if (!drawer) return;

    var freeShipThreshold = parseInt(drawer.dataset.freeShipThreshold || '0', 10);
    var freeGiftThreshold = parseInt(drawer.dataset.freeGiftThreshold || '0', 10);
    var currency = drawer.dataset.currency || 'CLP';

    var itemsEl = drawer.querySelector('[data-florema-cart-items]');
    var emptyEl = drawer.querySelector('[data-florema-cart-empty]');
    var totalEl = drawer.querySelector('[data-florema-cart-total]');
    var barEl = drawer.querySelector('[data-florema-cart-bar]');
    var progressTextEl = drawer.querySelector('[data-florema-cart-progress-text]');
    var noteEl = drawer.querySelector('[data-florema-cart-note]');
    var milestoneShip = drawer.querySelector('[data-florema-cart-milestone="ship"]');
    var milestoneGift = drawer.querySelector('[data-florema-cart-milestone="gift"]');
    var giftAlertEl = drawer.querySelector('[data-florema-cart-gift-alert]');

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      refresh();
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    drawer.querySelectorAll('[data-florema-cart-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // ── Render ──
    function render(cart) {
      // Items
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="florema-cart-drawer__empty"><p>Tu carrito está vacío.</p></div>';
      } else {
        var html = '';
        cart.items.forEach(function (item, idx) {
          var img = item.image ? item.image.replace(/\.([a-z]+)$/, '_200x.$1') : '';
          var variantText = item.variant_title && item.variant_title !== 'Default Title'
            ? '<div class="florema-cart-drawer__item-variant">' + escapeHtml(item.product_title.includes(item.variant_title) ? '' : item.variant_title) + '</div>'
            : '';

          // Detección de descuento (esencia de regalo u otra promo)
          var hasDiscount = (item.original_line_price || 0) > (item.final_line_price || item.line_price || 0);
          var isFree = (item.final_line_price || item.line_price || 0) === 0;

          // Capturar título del descuento (Pack 2u/3u/5u, Esencia regalo, etc.)
          var discountTitle = '';
          var discountAmount = 0;
          if (item.discounts && item.discounts.length) {
            discountTitle = item.discounts[0].title || '';
            discountAmount = item.discounts[0].amount || 0;
          } else if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
            var alloc = item.line_level_discount_allocations[0];
            if (alloc.discount_application) discountTitle = alloc.discount_application.title || '';
            discountAmount = alloc.amount || 0;
          }

          var isGift = isFree;
          var totalHTML;
          var unitHTML;
          var discountLabelHTML = '';

          if (hasDiscount) {
            totalHTML = ''
              + '<div class="florema-cart-drawer__item-total florema-cart-drawer__item-total--discounted">'
              +   '<span class="florema-cart-drawer__item-total-original">' + fmt(item.original_line_price) + '</span>'
              +   '<span class="florema-cart-drawer__item-total-final">' + (isGift ? 'Regalo 🎁' : fmt(item.final_line_price || item.line_price)) + '</span>'
              + '</div>';

            if (isGift) {
              unitHTML = '<div class="florema-cart-drawer__item-price florema-cart-drawer__item-price--gift">🎁 Esencia de regalo</div>';
            } else {
              unitHTML = '<div class="florema-cart-drawer__item-price">' + fmt(item.line_price) + '</div>';
              // Label visible del descuento aplicado
              if (discountTitle) {
                discountLabelHTML = ''
                  + '<div class="florema-cart-drawer__item-discount">'
                  +   '<span class="florema-cart-drawer__item-discount-tag" aria-hidden="true">'
                  +     '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
                  +   '</span>'
                  +   '<span class="florema-cart-drawer__item-discount-text">' + escapeHtml(discountTitle) + (discountAmount ? ' <strong>(-' + fmt(discountAmount) + ')</strong>' : '') + '</span>'
                  + '</div>';
              }
            }
          } else {
            totalHTML = '<div class="florema-cart-drawer__item-total">' + fmt(item.original_line_price) + '</div>';
            unitHTML = '<div class="florema-cart-drawer__item-price">' + fmt(item.line_price) + '</div>';
          }

          var itemModifierClass = '';
          if (isGift) itemModifierClass = ' florema-cart-drawer__item--gift';
          else if (hasDiscount) itemModifierClass = ' florema-cart-drawer__item--pack';

          html += ''
            + '<div class="florema-cart-drawer__item' + itemModifierClass + '" data-line="' + (idx + 1) + '" data-key="' + escapeHtml(item.key) + '">'
            +   '<a href="' + escapeHtml(item.url) + '" class="florema-cart-drawer__item-img">'
            +     (img ? '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '')
            +   '</a>'
            +   '<div class="florema-cart-drawer__item-info">'
            +     '<a href="' + escapeHtml(item.url) + '" class="florema-cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>'
            +     unitHTML
            +     discountLabelHTML
            +     variantText
            +     '<div class="florema-cart-drawer__item-actions">'
            +       '<div class="florema-cart-drawer__qty">'
            +         '<button type="button" data-qty-minus aria-label="Restar">−</button>'
            +         '<input type="number" value="' + item.quantity + '" min="0" data-qty-input>'
            +         '<button type="button" data-qty-plus aria-label="Sumar">+</button>'
            +       '</div>'
            +       '<button type="button" class="florema-cart-drawer__item-remove" data-remove aria-label="Eliminar">'
            +         '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 7h14m-2 0v12a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V7m3 0V5a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v2"/></svg>'
            +       '</button>'
            +     '</div>'
            +   '</div>'
            +   totalHTML
            + '</div>';
        });
        itemsEl.innerHTML = html;

        // Bind qty controls
        itemsEl.querySelectorAll('[data-line]').forEach(function (lineEl) {
          var line = parseInt(lineEl.dataset.line, 10);
          lineEl.querySelector('[data-qty-minus]').addEventListener('click', function () {
            var input = lineEl.querySelector('[data-qty-input]');
            var v = parseInt(input.value, 10) || 1;
            updateLine(line, Math.max(0, v - 1));
          });
          lineEl.querySelector('[data-qty-plus]').addEventListener('click', function () {
            var input = lineEl.querySelector('[data-qty-input]');
            var v = parseInt(input.value, 10) || 1;
            updateLine(line, v + 1);
          });
          lineEl.querySelector('[data-qty-input]').addEventListener('change', function (e) {
            var v = parseInt(e.target.value, 10) || 0;
            updateLine(line, Math.max(0, v));
          });
          lineEl.querySelector('[data-remove]').addEventListener('click', function () {
            updateLine(line, 0);
          });
        });
      }

      // Total
      if (totalEl) totalEl.textContent = fmt(cart.total_price) + ' ' + currency;

      // Note
      if (noteEl && noteEl.value !== (cart.note || '')) noteEl.value = cart.note || '';

      // Progress bar — solo envío gratis
      var subtotal = cart.total_price;
      var pct = freeShipThreshold > 0 ? Math.min(100, (subtotal / freeShipThreshold) * 100) : 0;
      if (barEl) barEl.style.width = pct + '%';

      // Verde oscuro consistente
      if (barEl) {
        if (subtotal >= freeShipThreshold) {
          barEl.style.background = 'linear-gradient(to right, #2d4127, #1a2a14)'; // verde muy oscuro (completo)
        } else {
          barEl.style.background = 'linear-gradient(to right, #6b8259, #4a6741)'; // verde medio (avanzando)
        }
      }

      // Milestone envío gratis
      if (milestoneShip) {
        milestoneShip.classList.toggle('is-reached', subtotal >= freeShipThreshold);
      }

      // Contador en header
      var countEl = drawer.querySelector('[data-florema-cart-count]');
      if (countEl) {
        countEl.textContent = cart.item_count > 0 ? ' · ' + cart.item_count : '';
      }

      // Progress text — 2 estados
      if (progressTextEl) {
        if (subtotal >= freeShipThreshold) {
          progressTextEl.innerHTML = '🚚 <strong>¡Envío Gratis desbloqueado!</strong>';
        } else {
          var rem = freeShipThreshold - subtotal;
          progressTextEl.innerHTML = 'Agrega <strong>' + fmt(rem) + '</strong> más para <strong>Envío Gratis</strong> 🚚';
        }
      }

      // Update header cart counter (Dawn)
      var counters = document.querySelectorAll('.cart-count-bubble span:first-child, [data-cart-count]');
      counters.forEach(function (c) { c.textContent = cart.item_count; });

      // Complementary products upsell
      loadComplementary(cart);
    }

    // ── AJAX ──
    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }

    function refresh() {
      return fetchCart().then(render).catch(function (e) { console.error('Florema cart refresh error', e); });
    }

    function updateLine(line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(render);
    }

    function addItem(variantId, qty) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
      }).then(function (r) { return r.json(); }).then(function () { return refresh(); });
    }

    function updateNote(value) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value })
      });
    }

    // Note debounced save
    if (noteEl) {
      var noteTimer = null;
      noteEl.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () { updateNote(noteEl.value); }, 600);
      });
    }

    // ── Complementary products upsell ──
    var upsellEl = drawer.querySelector('[data-florema-cart-upsell]');
    var upsellListEl = drawer.querySelector('[data-florema-upsell-list]');
    var upsellToggleBtn = drawer.querySelector('[data-florema-upsell-toggle]');
    var lastUpsellProductId = null;

    // ── Toggle del upsell (colapsar/expandir) ──
    var UPSELL_COLLAPSED_KEY = 'florema_cart_upsell_collapsed';
    function applyUpsellCollapsedState() {
      if (!upsellEl || !upsellToggleBtn) return;
      var collapsed = false;
      try { collapsed = localStorage.getItem(UPSELL_COLLAPSED_KEY) === '1'; } catch (e) {}
      if (collapsed) {
        upsellEl.classList.add('is-collapsed');
        upsellToggleBtn.setAttribute('aria-expanded', 'false');
      } else {
        upsellEl.classList.remove('is-collapsed');
        upsellToggleBtn.setAttribute('aria-expanded', 'true');
      }
    }
    if (upsellToggleBtn) {
      upsellToggleBtn.addEventListener('click', function () {
        var isCollapsed = upsellEl.classList.toggle('is-collapsed');
        upsellToggleBtn.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
        try { localStorage.setItem(UPSELL_COLLAPSED_KEY, isCollapsed ? '1' : '0'); } catch (e) {}
      });
      applyUpsellCollapsedState();
    }

    function bindUpsellButtons() {
      if (!upsellListEl) return;
      upsellListEl.querySelectorAll('[data-florema-cart-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.dataset.variantId;
          if (!id) return;
          btn.disabled = true;
          addItem(id, 1).then(function () {
            btn.classList.add('is-added');
            btn.textContent = '✓';
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.textContent = '+';
              btn.disabled = false;
            }, 1500);
          }).catch(function () { btn.disabled = false; });
        });
      });
    }

    function loadComplementary(cart) {
      if (!upsellEl || !upsellListEl) return;

      // Hide if cart empty
      if (cart.item_count === 0) {
        upsellEl.hidden = true;
        lastUpsellProductId = null;
        return;
      }

      var productId = cart.items[0].product_id;
      // Only re-fetch if the leading product changed
      if (productId === lastUpsellProductId) return;
      lastUpsellProductId = productId;

      // IDs already in cart — we'll filter them out
      var inCart = cart.items.map(function (i) { return i.product_id; });

      fetch('/recommendations/products.json?product_id=' + productId + '&intent=complementary&limit=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.products || []).filter(function (p) {
            return inCart.indexOf(p.id) === -1;
          }).slice(0, 4);

          if (products.length === 0) {
            upsellEl.hidden = true;
            return;
          }

          var html = products.map(function (p) {
            var img = p.featured_image
              ? p.featured_image.replace(/\.([a-z]+)(\?.*)?$/, '_120x.$1')
              : '';
            var price = fmt(p.price_min);
            var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
            return ''
              + '<div class="florema-cart-drawer__upsell-item">'
              +   '<a href="' + escapeHtml(p.url) + '" class="florema-cart-drawer__upsell-img">'
              +     (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="56" height="56">' : '')
              +   '</a>'
              +   '<div class="florema-cart-drawer__upsell-info">'
              +     '<a href="' + escapeHtml(p.url) + '" class="florema-cart-drawer__upsell-name">' + escapeHtml(p.title) + '</a>'
              +     '<span class="florema-cart-drawer__upsell-price">' + price + '</span>'
              +   '</div>'
              +   '<button type="button" class="florema-cart-drawer__upsell-add" data-florema-cart-add data-variant-id="' + variantId + '" aria-label="Agregar">+</button>'
              + '</div>';
          }).join('');

          upsellListEl.innerHTML = html;
          upsellEl.hidden = false;
          bindUpsellButtons();
        })
        .catch(function () { upsellEl.hidden = true; });
    }

    // ── Hooks: open drawer on cart icon click + after add to cart ──

    // Cart icon clicks (Dawn header has links to /cart)
    function isCartIconClick(target) {
      var a = target.closest('a, button');
      if (!a) return false;
      // Selector explícito del icono de Florema (más confiable que href matching)
      if (a.matches('[data-florema-cart-icon], .florema-hdr__cart')) return true;
      if (a.closest('[data-florema-cart-icon], .florema-hdr__cart')) return true;
      var href = a.getAttribute('href') || '';
      // /cart, /cart/, /cart#, /cart? — open drawer
      if (href === '/cart' || href === '/cart/' || href.indexOf('/cart?') === 0 || href.indexOf('/cart#') === 0) return true;
      // Buttons triggering Dawn's native cart-drawer
      if (a.matches('a[href="#cart-drawer"], .header__icon--cart, [data-cart-icon-bubble]')) return true;
      return false;
    }

    document.addEventListener('click', function (e) {
      if (isCartIconClick(e.target)) {
        e.preventDefault();
        e.stopPropagation();
        open();
      }
    }, true);

    // Intercept all product form submits (PDP add to cart) and quick-adds
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = form.getAttribute('action') || '';
      if (!action.includes('/cart/add')) return;

      // Skip if already a fetch (handled elsewhere)
      if (form.dataset.floremaCartIntercepted) return;

      e.preventDefault();
      var fd = new FormData(form);
      var btn = form.querySelector('button[type="submit"]');
      var btnTextEl = btn && btn.querySelector('[data-pdp-add-text]');
      var origText = btnTextEl ? btnTextEl.innerHTML : (btn ? btn.innerHTML : '');

      if (btn) btn.disabled = true;
      if (btnTextEl) btnTextEl.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () { return refresh(); })
        .then(function () {
          open();
          if (btn) btn.disabled = false;
          if (btnTextEl) btnTextEl.innerHTML = origText;
        })
        .catch(function (err) {
          console.error('Cart add error', err);
          if (btn) btn.disabled = false;
          if (btnTextEl) btnTextEl.innerHTML = origText;
        });
    });

    // Initial render (in case cart is not empty on load)
    refresh();

    // Expose minimal API
    window.FloremaCart = { open: open, close: close, refresh: refresh, add: addItem };
  }

  ready(init);
})();
